/**
 * @generated SignedSource<<c23aca0a296088ae071c582937f841c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpAbout_nftItem$data = {
  readonly creatorAddress: {
    readonly publicProfile: {
      readonly profileName: string | null;
    } | null;
    readonly publicProfileUrl: string | null;
  } | null;
  readonly exhibitions: ReadonlyArray<{
    readonly heroBanner: ReadonlyArray<{
      readonly bannerConfig: {
        readonly eyeBrow?: string | null;
      } | null;
    } | null> | null;
    readonly urlLabel: string | null;
  } | null> | null;
  readonly metadata: {
    readonly createdYear?: string | null;
    readonly description?: string | null;
    readonly media?: {
      readonly url: string | null;
    } | null;
    readonly name?: string | null;
  } | null;
  readonly tokenUri: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"detailHelpers_nftItem">;
  readonly " $fragmentType": "NftPdpAbout_nftItem";
};
export type NftPdpAbout_nftItem$key = {
  readonly " $data"?: NftPdpAbout_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpAbout_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpAbout_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "detailHelpers_nftItem"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenUri",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "creatorAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicProfileUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NftDigitalArtMetadataMedia",
              "kind": "LinkedField",
              "name": "media",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "NftDigitalArtMetadata",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftCmsExhibitionPage",
      "kind": "LinkedField",
      "name": "exhibitions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NftCmsExhibitionHeroBannerType",
          "kind": "LinkedField",
          "name": "heroBanner",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "bannerConfig",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eyeBrow",
                      "storageKey": null
                    }
                  ],
                  "type": "NftCmsExhibitionHtmlBannerType",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "cfd7f3c1a5aeacbfcae402a5db7d67c8";

export default node;
